{/*import React from "react";
import { Link } from "react-router-dom";*/}

function CampusAmbassadorPageTwo() {
  return (

    <div className="max-w-5xl mx-auto px-6 py-16">
      <h1 className="text-5xl font-extrabold mb-4 tracking-tight">
        Intuuch Campus Ambassador 
      </h1>
      <p className="text-lg text-gray-700 mb-10 leading-relaxed">
        ☁️ Do More. Live More. Together, we can help create connections and make lasting memories. ☁️
      </p>

      <p className="text-lg mb-6 leading-relaxed">
        Remote
      </p>
   

      <section className="space-y-8 text-gray-700">
         {/*
        <h2 className="text-2xl font-bold text-gray-900">About the Team</h2>

        <p>
        Intuuch is a social app that helps you create plans with friends, meet new people, and stay in touch. 
        This fall, we’re bringing Intuuch to college campuses to help students feel more connected on campus, and we’re looking for your help! 
        If you’re excited to help shape a product that brings people together, come join us as we launch on college campuses across the U.S.!
        </p>

     
         We’re looking for outgoing, creative, and community-driven students
          who believe in this vision to represent us as college ambassadors and build their campus community on Intuuch. 
        <p>

          If you love meeting new people, planning events, and getting your campus in on what’s new and fun, this is{" "}
          <em>your</em> moment to shine.
        </p>*/}

        <hr className="my-10 border-gray-200" />

        <h2 className="text-2xl font-bold text-gray-900">About the Role</h2>


     
        <p>
        Intuuch is a social app that helps you create plans with friends, meet new people, and stay in touch. 
        This fall, we’re bringing Intuuch to college campuses to help students feel more connected on campus, and we’re looking for your help! 
        If you’re excited to help shape a product that brings people together, come join us as we launch on college campuses across the U.S.!
        </p>

        <p>We’re looking for current students with a passion for marketing to join us as a Paid Brand Ambassador. You will join a passionate group of ambassadors on campus, create engaging content for Instagram and Tiktok, while building connections and gaining valuable marketing experience, and have the opportunity to make a true impact by hosting events on campus!
          </p>
        
        <p>
          This role is ideal for someone who is outgoing, resourceful, and motivated to build something meaningful from the ground up. 
          You should be comfortable taking initiative, thinking creatively, and engaging with diverse student communities both online and offline.
           Most importantly, we’re looking for ambassadors who are passionate about community, love meeting new people, and genuinely excited about creating connections on campus.
        </p>

        {/*}

         <p>------------</p>

          I really like these, need to edit the draft later:
            <p>
          You’ll have the chance to gain hands-on experience in marketing, community engagement, sales, event planning, and creative promotion, all while building your leadership and communication skills.
          You’ll develop expertise in connecting with local communities, finding innovative ways to engage students to drive customer adoption, and helping grow our presence on campus.
          You will building relationships with students and campus organizations, while driving adoption to make our app a part of student life.         
        </p>

             <p>
          This role is perfect for students who enjoy a flexible, dynamic work environment and want to be part of an exciting service that caters to their fellow students. 
          You must be a high energy, personable and motivated self-starter. We are looking for enthusiastic & outgoing students who are able to commit 5 hours a week, and who can tackle hard problems with relentless persistence. 
          Above all else, we are looking for team members who are driven and as excited as we are to provide an amazing new service to students!
        </p>
        */}

        <h2 className="text-2xl font-bold text-gray-900">Responsibilities</h2>
        <ul className="list-disc list-inside space-y-2">
          {/*<li>Spread the word about Intuuch on campus through creative ideas and building connections with other students.</li>*/}
          <li>Host events regularly while growing awareness and attendance</li>
          <li>Building connections and creating partnerships on campus</li>
          <li>Create engaging short-form videos and ensure timely delivery of tasks</li>
          <li>Stay up-to-date with current trends and identify new content opportunities</li>
          {/*<li>Make new friends and build a strong network within the campus community by collaborating with important student organizations and local hotspots.</li> this is VBTM, should edit later*/}
          <li>Collect feedback and share insights from your campus experience</li>
         {/*} <li>Take ownership of projects and contribute to different areas of the startup, from marketing and partnerships to product feedback and event planning.</li>*/}
        </ul>

        <h2 className="text-2xl font-bold text-gray-900">Who we're lookng for..</h2>
        <ul className="list-disc list-inside space-y-2">
          {/*<li>Spread the word about Intuuch on campus through creative ideas and building connections with other students.</li>*/}
          <li><b>Currently Pursuing a Degree:</b> You are enrolled in a Bachelor’s program in Marketing, Communications, Economics, Business, or a related field.</li>
          <li><b>Passionate About Marketing, Social Media and Tech:</b> You have a strong interest in marketing, advertising, sales, social media or event planning, and you’re eager to learn and gain hands-on experience.</li>
          <li><b>Strong leadership, communication and collaboration skills:</b> You can strike up a conversation with anyone, whether its students, club leaders, or local business owners, and build strong connections.</li>
          <li><b>Creative and Innovative:</b> You’re full of ideas and eager to experiment with new ways to make an impact on your campus. You have a strong understanding of TikTok trends, meme culture, and viral content strategies</li>
          <li><b>Resourceful and Hands-On:</b> You’re ready to do whatever it takes to execute a great idea, from running events to managing small logistics.</li>
          <li><b>Content Creation Experience:</b> Experience creating and editing engaging short-form video content is a plus.</li>

          {/*}
          <li><b>Self-Motivated and Energetic:</b> You thrive on independence, bring a positive attitude, and take initiative to make things happen.</li>
          <li><b>Independent & Collaborative:</b> You can work effectively on your own or as part of a team, take initiative, and maintain a positive, can-do attitude in every project.</li>
          */}
        </ul>

        <hr className="my-10 border-gray-200" />

        {/*<h2 className="text-2xl font-bold text-gray-900">📆 Program Dates</h2>
        <p><strong>Academic Year:</strong> 2025–2026</p>*/}

{/*}
        <h2 className="text-2xl font-bold text-gray-900 mt-10">Eligibility</h2>
        <p>
          This program is open to <strong>full-time college students</strong> currently enrolled in accredited
          universities or colleges. 
        </p>

        <hr className="my-10 border-gray-200" />*/}
       {/*
        <h2 className="text-2xl font-bold text-gray-900 mt-10">Program Details</h2>
        <ul className="list-disc list-inside space-y-2">
          <li> <strong>Pay:</strong>  $ 16/hr </li>
          <li><strong>Commitment:</strong>  1 - 4 hrs/wk </li>
          <li><strong>Program Start Date:</strong>  Mid - Late Jan, 2026 </li>
          <li><strong>Program End Date:</strong>  May 31, 2026 </li>
        </ul>

        <hr className="my-10 border-gray-200" />*/}
{/*}
        <h2 className="text-2xl font-bold text-gray-900">How to Apply</h2>
        <p>
          Ready to make campus life even more connected? Complete our 5 min questionaire to be considered for the{" "}
          <strong>2025–2026 Intuuch College Ambassador Program</strong>! Our team will carefully review your submission
          and reach out if you’re selected for an open position.
        </p>
        This position pays $17–$18 per hour, depending on your location.
        */}
        <p>
          This is a paid position. Applications will be reviewed on a rolling basis.
        </p>

        <div className="flex justify-center mt-10">
          <a
            href="https://forms.gle/Rc9FdN85RqpRaesC6"
            target="_blank"
            rel="noopener noreferrer"
            className="px-6 py-3 bg-cyan-600 text-white rounded-full text-lg font-semibold hover:bg-cyan-700 transition-colors"
          >
            Apply
          </a>
        </div>
        <p className="text-center text-gray-500 text-sm mt-8">
          👭 Be part of the community bringing people together ♥️
        </p>
      </section>
    </div>

  );
}

export default CampusAmbassadorPageTwo;
